export const environment = {
    orgId: 'aiema',
    production: true,
    apiURL:"https://aiema.ecbee.net"
  };
  